import { createRoute, redirect } from '@tanstack/react-router'
import { Route as rootRoute } from '@/app/__root'
import { ROUTES } from '@/shared/constants/routes'
import { queryClient, sessionQueryOptions } from '@/shared/lib/tanstack'
import { AUTH_TOKEN_KEY } from '@/shared/constants/auth'
import { getSecureItem } from '@/shared/lib/storage'
import { getLoginRedirectSearch } from '@/pages/home/page.home.hook'
import { FEATURE_FLAGS } from '@/shared/constants/feature-flags'
import { withFeatureGate } from '@/components/molecules'
import { ClaimsPetPage } from './page.claims.pet'

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: ROUTES.CLAIMS_PET,
  beforeLoad: async ({ location }) => {
    const token = await getSecureItem(AUTH_TOKEN_KEY)
    if (!token) {
      throw redirect({
        to: ROUTES.LOGIN,
        search: getLoginRedirectSearch(location),
      })
    }
    const session = await queryClient.ensureQueryData(sessionQueryOptions)
    if (!session?.user) {
      throw redirect({
        to: ROUTES.LOGIN,
        search: getLoginRedirectSearch(location),
      })
    }
  },
  component: withFeatureGate(FEATURE_FLAGS.WEB_APP_CLAIMS, ClaimsPetPage, {
    redirectTo: ROUTES.CLAIMS,
  }),
})
